import {apiUrl} from '../../context/context';
import {acerillAuthenticatedAxios} from './acerill-axios-instances';

const baseUrl = `${apiUrl}/custom-forms/v2`;

const findAllForms = includeNotifications => {
  const params = {};
  if (includeNotifications != null) {
    params.include_notifications = includeNotifications;
  }
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/forms`, {params})
    .then(response => response.data || []);
};

const findFormById = async id => {
  const {data} = await acerillAuthenticatedAxios.get(`${baseUrl}/forms/${encodeURIComponent(id)}`);
  return data;
};

const createDefaultForm = () => {
  return acerillAuthenticatedAxios
    .post(`${baseUrl}/forms`, null)
    .then(response => response.data);
};

const updateForm = form => {
  return acerillAuthenticatedAxios
    .patch(
      `${baseUrl}/forms/${encodeURIComponent(form.id)}`,
      form
    )
    .then(response => response.data);
};

const deleteForm = id => {
  return acerillAuthenticatedAxios
    .delete(`${baseUrl}/forms/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const findAllFormsWithSubmissions = () => {
  return acerillAuthenticatedAxios
    .get(baseUrl + '/forms-with-submissions')
    .then(response => response.data);
};

const findFormSubmissionsWithValues = (formId, pageSize, fromKeyExcl, timezone) => {
  return acerillAuthenticatedAxios
    .get(
      baseUrl + '/form-submissions/values',
      {
        params: {form_id: formId, page_size: pageSize, from_key_excl: fromKeyExcl, desc: 'true', timezone: timezone},
      }
    )
    .then(response => response.data);
};

const saveFormNotification = (formId, notification) => {
  return acerillAuthenticatedAxios
    .put(
      `${baseUrl}/forms/${encodeURIComponent(formId)}/notifications/${encodeURIComponent(notification.id)}`,
      notification
    )
    .then(response => response.data);
};

const findFormNotificationById = (formId, notificationId) => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/forms/${encodeURIComponent(formId)}/notifications/${encodeURIComponent(notificationId)}`)
    .then(response => response.data);
};

const deleteFormNotification = (formId, notificationId) => {
  return acerillAuthenticatedAxios
    .delete(`${baseUrl}/forms/${encodeURIComponent(formId)}/notifications/${encodeURIComponent(notificationId)}`)
    .then(response => response.data);
};

const sendSubmissionNotificationTest = submission => {
  return acerillAuthenticatedAxios
    .post(
      `${baseUrl}/submission-notifications/email/test`,
      submission
    )
    .then(response => response.data);
};

const findGoogleSheetsIntegrationById = id => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/google-sheets/integrations/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const saveGoogleSheetsIntegration = integration => {
  return acerillAuthenticatedAxios
    .put(
      `${baseUrl}/google-sheets/integrations/${encodeURIComponent(integration.id)}`,
      integration
    )
    .then(response => response.data);
};

const deleteGoogleSheetsIntegration = id => {
  return acerillAuthenticatedAxios
    .delete(`${baseUrl}/google-sheets/integrations/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const findRecaptchaKeyPairById = id => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/recaptcha/key-pairs/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const saveRecaptchaKeyPair = keyPair => {
  return acerillAuthenticatedAxios
    .put(
      `${baseUrl}/recaptcha/key-pairs/${encodeURIComponent(keyPair.id)}`,
      keyPair
    )
    .then(response => response.data);
};

const deleteRecaptchaKeyPair = id => {
  return acerillAuthenticatedAxios
    .delete(`${baseUrl}/recaptcha/key-pairs/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const findShopifyIntegrationById = id => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/shopify/integrations/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const saveShopifyIntegration = integration => {
  return acerillAuthenticatedAxios
    .put(
      `${baseUrl}/shopify/integrations/${encodeURIComponent(integration.id)}`,
      integration
    )
    .then(response => response.data);
};

const deleteShopifyIntegration = id => {
  return acerillAuthenticatedAxios
    .delete(`${baseUrl}/shopify/integrations/${encodeURIComponent(id)}`);
};

const findZapierApiKey = () => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/zapier/api-key`)
    .then(response => response.data);
};

const sendZapierTriggerTestEvent = (triggerKey, payload) => {
  return acerillAuthenticatedAxios
    .post(
      `${baseUrl}/zapier/triggers/${encodeURIComponent(triggerKey)}/test`,
      payload
    );
};

const CustomFormsV2Client = {
  findAllForms,
  findFormById,
  createDefaultForm,
  updateForm,
  deleteForm,
  findAllFormsWithSubmissions,
  findFormSubmissionsWithValues,
  saveFormNotification,
  findFormNotificationById,
  deleteFormNotification,
  sendSubmissionNotificationTest,
  findGoogleSheetsIntegrationById,
  saveGoogleSheetsIntegration,
  deleteGoogleSheetsIntegration,
  findRecaptchaKeyPairById,
  saveRecaptchaKeyPair,
  deleteRecaptchaKeyPair,
  findShopifyIntegrationById,
  saveShopifyIntegration,
  deleteShopifyIntegration,
  findZapierApiKey,
  sendZapierTriggerTestEvent,
};
export default CustomFormsV2Client;
